var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeedPurple = function SvgSpeedPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speed-purple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#speed-purple_svg__b)",
    fillRule: "evenodd",
    d: "M7.5 1.333c0-.46.373-.833.834-.833h3.333a.833.833 0 1 1 0 1.667H8.334a.833.833 0 0 1-.834-.834M10 4.667a6.667 6.667 0 0 0-6.666 6.666.833.833 0 1 1-1.667 0A8.333 8.333 0 1 1 10 19.667H5.834a.833.833 0 0 1 0-1.667H10a6.667 6.667 0 0 0 0-13.333M10 8c.46 0 .834.373.834.833v3.334a.833.833 0 0 1-1.667 0V8.833c0-.46.373-.833.833-.833M.833 13.833c0-.46.374-.833.834-.833h4.167a.833.833 0 1 1 0 1.667H1.667a.833.833 0 0 1-.834-.834m1.667 2.5c0-.46.373-.833.833-.833h5a.833.833 0 1 1 0 1.667h-5a.833.833 0 0 1-.833-.834",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "speed-purple_svg__b",
    x1: 0.833,
    x2: 18.334,
    y1: 10.454,
    y2: 10.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "speed-purple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v20H0z"
  })))));
};
export default SvgSpeedPurple;